import { StateCreator } from 'zustand';

export const initialState = {
    emailVerified: false,
    email: '',
    roles: [],
    username: '',
    groups: '',
    tenantKey: '',
    customerId: '',
    userId: '',
    firstName: '',
    lastName: '',
    landlordId: '',
    tableauToken: ''
};

export interface UserSlice {
    user: User;
    setUser?: (user: User) => void;
}

export const createUserSlice: StateCreator<UserSlice, [], [], UserSlice> = (set) => ({
    user: { ...initialState },
    setUser: (user: User) =>
        set((state) => ({
            user: {
                ...state.user,
                ...user
            }
        }))
});
